import {define, inject, singleton} from '@injex/core';
import SocketManager from '../../../common/managers/SocketManager.mdl';
import {BaseReportsManager} from './baseReportsManager';
import ReportingParamsManagerMdl from './reportingParamsManager.mdl';

@define()
@singleton()
export class RegularReportsManager extends BaseReportsManager {

    @inject() private socketManager: SocketManager;
    @inject() private reportingParamsManager: ReportingParamsManagerMdl;

    public async get(): Promise<void> {
        try {
            this.reportingParamsManager.setStorageParams();

            if (this.reportingParamsManager.params.isCompare) {
                return this.getCompare();
            }

            return this.getReport();

        } catch (e) {
            await this.hooks.onReportError.call()
        }
    }

    public async getReport() {
        const params = this.reportingParamsManager.preparedParams;
        const results = await this.socketManager.reporting.getReporting(params);
        await this.hooks.onReportReady.call(results)

    }

    public async getCompare() {
        const params = this.reportingParamsManager.preparedParams;
        const results = await this.socketManager.reporting.getCompareReporting(params);
        await this.hooks.onReportReady.call(results)
    }
}
